var _style, _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _circle, _circle2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg01Process(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    x: 0,
    y: 0,
    xmlSpace: "preserve",
    width: 186.56,
    height: 137.922,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css",
    id: "style2"
  }, ".st159{fill:#f7a4a4}.st161{fill:#716376}.st162{fill:#472f36}.st163{fill:#49393c}.st165{fill:#fed51c}")), /*#__PURE__*/React.createElement("g", {
    id: "g632",
    transform: "translate(-48 -800.078)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M223.779 855.108c-14.337-17.001-47.392 7.802-55.52-13.302-9.642-25.035-29.804-53.895-54.659-36.345-21.458 15.152-3.694 41.068-21.482 55.26-9.262 7.39-38.978 10.435-25.829 39.768 6.595 14.713 6.638 20.897 20.513 26.399 27.054 10.727 37.89-10.622 61.583-16.099 21.82-5.045 46.712 24.471 68.257 8.854 20.918-15.161 23.817-44.755 7.137-64.535z",
    id: "path548",
    style: {
      fill: "#ecf0f1"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g630"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st159",
    d: "M81.482 900.069h10.987a4.546 4.546 0 0 0 4.546-4.547v-8.538a4.547 4.547 0 0 0-4.546-4.547H81.482a4.546 4.546 0 0 0-4.546 4.547v8.538a4.546 4.546 0 0 0 4.546 4.547z",
    id: "path550"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M86.464 900.069h10.987a4.546 4.546 0 0 0 4.546-4.547v-8.538a4.547 4.547 0 0 0-4.546-4.547H86.464a4.546 4.546 0 0 0-4.546 4.547v8.538a4.546 4.546 0 0 0 4.546 4.547z",
    id: "path552",
    style: {
      fill: "#fff"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st159",
    d: "M91.192 896.102h1.347a4.849 4.849 0 0 0 0-9.698h-1.347a4.848 4.848 0 0 0-4.848 4.849 4.848 4.848 0 0 0 4.848 4.849z",
    id: "path554"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M94.322 896.102h1.347a4.849 4.849 0 0 0 0-9.698h-1.347a4.848 4.848 0 0 0-4.848 4.849 4.848 4.848 0 0 0 4.848 4.849z",
    id: "path556",
    style: {
      fill: "#ffc3c2"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g560"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st159",
    d: "M204.643 926.266c.089 0 .18-.018.267-.058 3.132-1.431 10.342-5.493 9.644-12.296-.673-6.562-5.656-12.052-11.591-12.771-3.551-.428-7.412.387-12.151 2.57-1.312.604-2.617 1.27-3.878 1.914-2.299 1.173-4.677 2.386-7.133 3.241-6.564 2.287-14.221 2.178-21.562-.307-6.255-2.117-11.513-6.27-16.598-10.286-5.911-4.668-12.024-9.495-19.766-11.208-8.705-1.925-17.415.683-25.84 3.208l-1.222.365a.643.643 0 1 0 .368 1.232l1.224-.366c8.267-2.477 16.816-5.037 25.193-3.184 7.454 1.649 13.182 6.172 19.247 10.962 5.171 4.084 10.518 8.306 16.983 10.495 7.61 2.576 15.564 2.684 22.397.304 2.539-.885 4.956-2.118 7.295-3.31 1.25-.638 2.543-1.297 3.832-1.891 4.513-2.079 8.155-2.86 11.459-2.461 5.354.648 9.853 5.646 10.467 11.625.613 5.975-6.019 9.68-8.899 10.996a.643.643 0 0 0-.318.852.637.637 0 0 0 .582.374z",
    id: "path558"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st161",
    id: "polygon562",
    d: "M221.921 803.992h-65.568l-37.712 30.858h65.568z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st162",
    id: "polygon564",
    d: "M221.921 812.135h-65.568l-37.712 30.857h65.568z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st163",
    id: "polygon566",
    d: "M221.921 820.278h-65.568l-37.712 30.857h65.568z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st162",
    d: "M167.368 851.135h16.841l37.712-30.857h-65.568c-12.651 10.352-5.332 30.857 11.015 30.857z",
    id: "path568"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st161",
    id: "polygon570",
    d: "M156.353 812.135v-8.143l-37.712 30.858v8.142z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st163",
    id: "polygon572",
    d: "M156.353 820.278v-8.143l-37.712 30.857v8.143z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "polygon574",
    style: {
      fill: "#5a4b5a"
    },
    d: "M221.921 812.135h-65.568v-8.143h65.568v.357z"
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st162",
    id: "polygon576",
    d: "M221.921 820.278h-65.568v-8.143h65.568v.357z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "g580"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st161",
    d: "M150.049 931.786a5.357 5.357 0 0 0 5.283-6.28l-10.784-61.727a5.358 5.358 0 0 0-10.554 1.844l10.784 61.727a5.359 5.359 0 0 0 5.271 4.436z",
    id: "path578"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "g584"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st163",
    d: "M139.266 870.059a5.357 5.357 0 0 0 5.283-6.28l-2.867-16.409a5.357 5.357 0 0 0-10.554 1.844l2.867 16.409a5.358 5.358 0 0 0 5.271 4.436z",
    id: "path582"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "g588"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st161",
    d: "M205.523 931.786a5.357 5.357 0 0 0 5.283-6.28l-10.784-61.727a5.357 5.357 0 0 0-10.554 1.844l10.784 61.727a5.359 5.359 0 0 0 5.271 4.436z",
    id: "path586"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "g592"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st162",
    d: "M194.74 870.059a5.357 5.357 0 0 0 5.283-6.28l-5.609-32.105a5.357 5.357 0 0 0-10.554 1.844l5.609 32.105a5.359 5.359 0 0 0 5.271 4.436z",
    id: "path590"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "g596"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st163",
    d: "M161.531 938h47.819c5.917 0 10.714-4.797 10.714-10.714 0-5.917-4.797-10.714-10.714-10.714h-47.819c-5.917 0-10.714 4.797-10.714 10.714 0 5.917 4.797 10.714 10.714 10.714z",
    id: "path594"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "g600"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st162",
    d: "M146.36 938h62.991c5.917 0 10.714-4.797 10.714-10.714 0-5.917-4.797-10.714-10.714-10.714H146.36c-5.917 0-10.714 4.797-10.714 10.714 0 5.917 4.797 10.714 10.714 10.714z",
    id: "path598"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "g604"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st163",
    d: "M58.714 938h89.075c5.917 0 10.714-4.797 10.714-10.714 0-5.917-4.797-10.714-10.714-10.714H58.714c-5.917 0-10.714 4.797-10.714 10.714C48 933.203 52.797 938 58.714 938z",
    id: "path602"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "g608"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st163",
    d: "M116.362 830.258h20.462a2.143 2.143 0 0 0 0-4.286h-20.462a2.143 2.143 0 0 0 0 4.286z",
    id: "path606"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "g612"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st162",
    d: "M204.642 830.258h20.462a2.143 2.143 0 0 0 0-4.286h-20.462a2.143 2.143 0 0 0 0 4.286z",
    id: "path610"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "g616"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st161",
    d: "M58.714 932.643h84.517a5.358 5.358 0 0 0 0-10.714H58.714a5.358 5.358 0 0 0 0 10.714z",
    id: "path614"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "g620"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st165",
    d: "M131.937 834.258c.477 0 .957-.159 1.356-.484l11.295-9.242a2.144 2.144 0 0 0-2.713-3.318l-11.295 9.242a2.144 2.144 0 0 0 1.357 3.802z",
    id: "path618"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g624"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M182.781 814.278h18.285a2.143 2.143 0 0 0 0-4.286h-18.285a2.143 2.143 0 0 0 0 4.286z",
    id: "path622",
    style: {
      fill: "#f29512"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st165",
    cx: 59.892,
    cy: 927.286,
    r: 2.893,
    id: "circle626"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st165",
    cx: 141.271,
    cy: 927.286,
    r: 2.893,
    id: "circle628"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg01Process);
export default __webpack_public_path__ + "static/media/01-Process.e1d703b6eb38dee2345c9bc83d1ef867.svg";
export { ForwardRef as ReactComponent };